cancelWatch